import { Component }	from '@angular/core';
import {
	ConfigService,
	SearchResult,
	SearchService
}											from '../../';

@Component({
  selector:			'electra-search-wrapper',
  styleUrls:		[ './searchWrapper.component.scss' ],
  templateUrl:	'./searchWrapper.component.html'
})
export class SearchWrapperComponent {
  searchResultsClass = 'hide';

	searchResultCount = 0;

	get searchClass(): string {
		return this.configService.mobile ? '' : 'desktop';
	}

	get searchResultsStyle(): any {
		return {
			height: (this.searchResultCount * 50 + 24) + 'px'
		};
	}

	constructor(private configService: ConfigService, private searchService: SearchService) {
    searchService.focused.subscribe(data => { this.gotSearchFocused(data); });
    searchService.searchResultsBS.subscribe(data => { this.gotSearchResults(data); });
  }

  gotSearchFocused(focused: boolean) {
    this.searchResultsClass = focused ? '' : 'hide';
  }

	gotSearchResults(searchResults: SearchResult[]) {
		this.searchResultCount = searchResults.length;
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/component/searchWrapper/searchWrapper.component.ts